import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CategoryFilterBody = _resolveComponent("CategoryFilterBody");
  const _component_FilterItem = _resolveComponent("FilterItem");
  return _openBlock(), _createBlock(_component_FilterItem, {
    id: "categories",
    ref: "categoryFilterItem",
    icon: "ProductsIcon",
    title: $options.getCategoryTitle,
    class: "category-filter",
    selectedTitle: $options.getCategorySelectedTitle,
    selectedCount: $props.categories?.filterState?.selectedCount,
    onClearAll: $options.handleClearAll,
    onApply: $options.onApply,
    onHidden: $options.onHidden
  }, {
    body: _withCtx(() => [_createVNode(_component_CategoryFilterBody, {
      title: "Category",
      selected: $props.categories?.filterState?.selected,
      isModified: $props.categories.isModified,
      pendingChanges: $props.categories.pendingChanges,
      isSearching: $props.categories.isSearching,
      keyword: $props.categories.keyword,
      list: $props.categories.displayList,
      onClear: $options.handleClear,
      onDiscard: $options.onDiscard,
      onRestoreSearch: $options.onRestoreSearch,
      onSelect: $options.handleSelect,
      onSelectOnly: $options.handleSelectOnly,
      onSelectAll: _cache[0] || (_cache[0] = $event => $props.categories.selectAll()),
      onDeselect: $options.handleDeselect,
      onApply: $options.onApply,
      onSearch: $options.handleCategorySearch,
      onHidden: $options.onHidden,
      onCloseDropdown: _ctx.$refs?.categoryFilterItem?.closeDropdown
    }, null, 8, ["selected", "isModified", "pendingChanges", "isSearching", "keyword", "list", "onClear", "onDiscard", "onRestoreSearch", "onSelect", "onSelectOnly", "onDeselect", "onApply", "onSearch", "onHidden", "onCloseDropdown"])]),
    _: 1
  }, 8, ["title", "selectedTitle", "selectedCount", "onClearAll", "onApply", "onHidden"]);
}